import { combineReducers } from "@reduxjs/toolkit";

import app from "./app";
import auth from "./auth";
import features from "./features";
import notifications from "./notifications";
import { actions, userReducer } from "./userSlice";

/** @deprecated We are phasing out `redux` */
const reducer = combineReducers({
  app,
  auth,
  features,
  notifications,
  user: userReducer,
});

/** @deprecated We are phasing out `redux` */
export const rootReducer: typeof reducer = (state, action) => {
  // catch the logout action and reset everything
  if (action.type === actions.logout.type) {
    return reducer(undefined, action);
  }

  // Remove profileOptions from state if it exists
  if (state && "profileOptions" in state) {
    const { profileOptions, ...restState } = state;
    return reducer(restState, action);
  }

  return reducer(state, action);
};
